import React from 'react';
import classNames from 'classnames';

import Alert from '../Alert/Alert';

import './StripeSubscriptionWarning.css';


const StripeSubscriptionWarning = (props) => {
  const classes = classNames(props.className, 'StripeSubscriptionWarning');

  return (
    <Alert className={classes} alertType="warning">
      <h4>
        Your subscription appears to have a problem.
        <br />
        <small>
          Please check your account status to book your next lesson
          (help@rypeapp.com)
        </small>
      </h4>
    </Alert>
  );
};

export default StripeSubscriptionWarning;



// WEBPACK FOOTER //
// ./src/components/alerts/StripeSubscriptionWarning/StripeSubscriptionWarning.js